export default __webpack_public_path__ + "static/media/Pink flare1.751908b0.jpg";